import React from 'react';
import { Box, Container, SimpleGrid, VStack, Heading, Text } from '@chakra-ui/react';

const SEOCopySection = () => {
	const sections = [
		{
			title: 'AI image production',
			description:
				'Creating professional images used to take days. Now you can create stunning visuals with AI in minutes using powerful AI image production tools designed for creative professionals.\n' +
				'\n' +
				'Imagemotion is an all-in-one AI image production studio that turns your ideas into photorealistic images, product photos and creative content automatically.\n' +
				'\n' +
				'Upload your reference and the AI image production engine generates visuals ready for any platform. This AI image production platform is the ultimate creative tool for creators who want to scale their visual content.',
		},
		{
			title: 'More Than an AI Image Tool —\n' + 'Your Complete AI Video Production Studio\n' + '\n',
			description:
				"Imagemotion is more than a simple AI tool. It's a complete AI image production and AI video production platform built to help creators produce content at scale. Our AI production platform ensures you never run out of creative possibilities. Our platform works as an all-in-one AI video production studio for creators, agencies and marketers, AI content generator for unlimited creative projects.",
		},
		{
			title: 'Everything You Need in AI Image & Video Production',
			description:
				"Our AI image production and AI video production platform combines creative generation, automation and workflow management in one powerful tool. The AI production suite you've been waiting for. Generate stunning visual storytelling and motion using the most advanced AI image production and AI video production technology. Create realistic content using our AI production tools — no expensive equipment required. Generate dozens of variations with the fastest AI production workflow available.",
		},
		{
			title: 'Stop Traditional Production. Start AI Production.',
			description:
				'Traditional content production is slow and expensive. Filming, editing and hiring teams can take weeks. Our AI image production and AI video production platform solves this problem instantly. Creators are switching to AI production because speed and quality matter. This AI production platform is your creative advantage. Your content is automatically optimized by our AI production engine for any use case. Create visuals designed for.',
		},
	];

	return (
		<Box as="section" borderTop="1px solid" borderColor="gray.100" bg="gray.50" py={24}>
			<Container maxW="1400px" px={8}>
				<SimpleGrid columns={{ base: 1, lg: 3 }} gap={16}>
					<Box gridColumn={{ base: 'auto', lg: 'span 1' }}>
						<VStack align="start" gap={4}>
							<Text
								fontSize="11px"
								fontWeight="500"
								textTransform="uppercase"
								letterSpacing="0.22em"
								color="gray.400"
							>
								About imagemotion
							</Text>
							<Heading fontSize="3xl" lineHeight="tight" letterSpacing="tight">
								The AI Image & Video Production Platform for Creators
							</Heading>
						</VStack>
					</Box>
					<Box gridColumn={{ base: 'auto', lg: 'span 2' }}>
						<SimpleGrid columns={{ base: 1, sm: 2 }} gapX={16} gapY={10}>
							{sections.map((section, index) => (
								<VStack key={index} align="start" gap={3}>
									<Text
										fontSize="13px"
										fontWeight="600"
										textTransform="uppercase"
										letterSpacing="0.16em"
										color="blackAlpha.800"
									>
										{section.title}
									</Text>
									<Text color="gray.500" fontSize="14px" lineHeight="1.75">
										{section.description}
									</Text>
								</VStack>
							))}
						</SimpleGrid>
					</Box>
				</SimpleGrid>
			</Container>
		</Box>
	);
};

export default SEOCopySection;
